var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationPinWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.9165C12.5 9.29725 11.3807 10.4165 10 10.4165C8.61925 10.4165 7.5 9.29725 7.5 7.9165C7.5 6.5358 8.61925 5.4165 10 5.4165C11.3807 5.4165 12.5 6.5358 12.5 7.9165Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.6665C13.3823 1.6665 16.25 4.5232 16.25 7.98892C16.25 11.5098 13.3357 13.9807 10.6437 15.6608C10.4476 15.7738 10.2257 15.8332 10 15.8332C9.77425 15.8332 9.55242 15.7738 9.35625 15.6608C6.66937 13.9643 3.75 11.522 3.75 7.98892C3.75 4.5232 6.61767 1.6665 10 1.6665Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.6665C15 17.587 12.7614 18.3332 10 18.3332C7.23857 18.3332 5 17.587 5 16.6665",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPinWhite);
export default __webpack_public_path__ + "static/media/location_pin_white.f47d3bf111bc866ee160c895d996af27.svg";
export { ForwardRef as ReactComponent };